import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { EventGallery } from '../components/EventGallery';
import { OpeningLead } from '../components/OpeningLead';
import { PainAmplification } from '../components/PainAmplification';
import { DreamSection } from '../components/DreamSection';
import { ComparisonTable } from '../components/ComparisonTable';
import { MirrorReveal } from '../components/MirrorReveal';
import { OurStory } from '../components/OurStory';
import { BenefitsTable } from '../components/BenefitsTable';
import { Testimonials } from '../components/Testimonials';
import { PackageList } from '../components/PackageList';
import { Guarantee } from '../components/Guarantee';
import { Urgency } from '../components/Urgency';
import { BookingCalendar } from '../components/BookingCalendar';
import { FinalCTA } from '../components/FinalCTA';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-ink font-sans text-cream selection:bg-gold/30 selection:text-white" data-id="element-528">
      <Header data-id="element-529" />
      <main data-id="element-530">
        <Hero data-id="element-531" />
        <EventGallery data-id="element-532" />
        <OpeningLead data-id="element-533" />
        <PainAmplification data-id="element-534" />
        <DreamSection data-id="element-535" />
        <ComparisonTable data-id="element-536" />
        <MirrorReveal data-id="element-537" />
        <OurStory data-id="element-538" />
        <BenefitsTable data-id="element-539" />
        <Testimonials data-id="element-540" />
        <PackageList data-id="element-541" />
        <Guarantee data-id="element-542" />
        <Urgency data-id="element-543" />
        <BookingCalendar data-id="element-544" />
        <FinalCTA data-id="element-545" />
        <FAQ data-id="element-546" />
      </main>
      <Footer data-id="element-547" />
    </div>;
}